import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContentFilters from './components/ContentFilter';
import { useFetchAllContents } from '@/data/swrs/trc';
import { useFormSubmit } from '@/hook/useFormSubmit';
import { handleErrorResponse } from '@/utils/handleErrorResponse';
import { deleteTrcContentApi } from '@/data/api/trc';
import { buildRoutes } from '@/service/buildRoutes';
import GenericListView from '@/AdminComponent/GenericListView';
import { FIELDS, LIST_LABELS } from '../components/utils/constants';
import { formatDisplayDate } from '@/component/formatDisplayDate';

const Content = () => {
  const [filters, setFilters] = useState({ type: '', search: '' });
  const fromAdmin = true;
  const { data : contents, error, mutate, isLoading } = useFetchAllContents( filters, fromAdmin );
  const items = contents?.data ?? [];

  const navigate = useNavigate();

  const handleEdit = (id) => navigate(buildRoutes.toTRCEditContent(id));
  const handleAdd = () => navigate(buildRoutes.toTRCAddContent());

  const handleDelete = useFormSubmit(async (id, token) => {
    const res = await deleteTrcContentApi({ id, token });
    if (handleErrorResponse(res)) return;
    mutate();
  });

  const renderButtons = (content) => [
    { title: 'Edit',   onClick: () => handleEdit(content?._id),   backgroundColor: '#9b92f4' },
    { title: 'Delete', onClick: () => handleDelete(content?._id), backgroundColor: '#ff0000' },
  ];

    const renderInfoElement = (content) => (
    <>
      <h2>{content?.[FIELDS.TITLE]}</h2>
      <p>
        {LIST_LABELS.INSTRUCTOR}: {content?.[FIELDS.INSTRUCTOR]}
      </p>
      <p>
        {LIST_LABELS.TYPE}: {(content?.[FIELDS.FILE_TYPE] || '').toUpperCase()}
      </p>
      <p>
        {LIST_LABELS.DATE_CREATED}: {formatDisplayDate(content?.updatedAt)}
      </p>
      <p>
        {LIST_LABELS.DATE_RELEASED}: {formatDisplayDate(content?.releaseDateTime)}
      </p>
    </>
  );

  const filterSlot = useMemo(
    () => <ContentFilters filters={filters} setFilters={setFilters} />,
    [filters]
  );

  return (
    <GenericListView
      title="TRC Content List"
      addLabel="Add Content"
      onAdd={handleAdd}
      filterSlot={filterSlot}
      items={items}
      error={error}
      isLoading={isLoading}
      renderButtons={renderButtons}
      renderInfoElement={renderInfoElement}
      gridItem={{ xs: 12, md: 12 }}
      imageStyle={{height: "20rem", width: "auto", marginRight: "3rem" }}
      getImage={(item) => item.thumnailLink || item.thumbnailLink || item.image || null}
    />
  );
};

export default Content;
